/** @format */

import toast from "react-hot-toast";
import { apiConfig } from "core-lib/config/config";
import { getMethod } from "core-lib/utils/apiV2";
import { getDefaultHeaders } from "core-lib/utils/network";
import { UserAddress } from "../types/types";
import { removeDuplicateValues } from "../utils/utils";

const serializeData = (data: any[]) => {
  const obj: UserAddress[] = data?.map((item: any) => ({
    id: item?.id,
    landmark: item?.landmark || "",
    locality: removeDuplicateValues(item) || "",
    city: item?.city || "",
    state: item?.state || "",
    stateCode: item?.state_code || "",
    latitude: item?.latitude,
    longitude: item?.longitude,
    pincode: item?.pincode || "",
    isActive: item?.active,
    address: item?.address || "",
    addressType: item?.address_type,
    addressTag: item?.secondary_address_type,
    metaData: {
      name: item?.user_address_meta?.name || "",
      email: item?.email_id || "",
      phone: item?.user_address_meta?.phone_number || "",
    },
  }));
  return obj;
};

export const fetchUserAddress = async () => {
  const endPoint = `${apiConfig("userNew")}/v1/user/address/update`;
  const { response, error }: any = await getMethod({
    endPoint,
    headers: getDefaultHeaders({ deviceId: true }),
  });

  if (response) {
    return {
      response: serializeData(response?.data)?.sort((a, b) => b.id - a.id),
    };
  } else if (error) {
    toast.error(error?.message || "Unable to fetch address");
    return { error: error };
  }
};
